import { useState } from "react";

const PanelInfoCollapsable = ({
    title,
    options,
    children,
    panelStyle = 'panel-info',
    showTitle = true,
    showCollapseButton = true,
}: {
  title: string;
  options?: any;
  children?: React.ReactNode;
  panelStyle?: string,
  showTitle?: boolean
  showCollapseButton?: boolean
}) => {
    const [showMore, setShowMore] = useState(true);
    const [isCollapse, setIsCollapse] = useState(false);

    return (
        <div className={`panel ${panelStyle} m-t-20`}>
            {(showTitle || showCollapseButton) && <div className="panel-heading">
                <>
                    {showTitle && <h2 className="panel-title title">{title}</h2>}
                    {showCollapseButton && <span
                        className="pull-right clickable"
                        onClick={() => setIsCollapse(!isCollapse)}
                    >
                        <i
                            className={`glyphicon ${
                                isCollapse ? "glyphicon-chevron-down" : "glyphicon-chevron-up"
                            }`}
                        ></i>
                    </span>}
                </>
            </div>}
            <div className={`panel-body summary ${isCollapse ? "hidden" : ""}`}>
                <div className={`collapse ${showMore ? "" : "show"}`}>
                    {children}
                    {!children &&
            options.map((item: any, index: number) => (
                <div className="col-md-4 list-style-1" key={index}>
                    <i className="fa fa-check"></i> {item.description}
                </div>
            ))}
                </div>
                <span
                    className={`toogle-content col-lg-12 col-md-12 ${showMore ? "collapsed" : ""}`}
                    onClick={() => setShowMore(!showMore)}
                >
                    {showMore ? "+ view full content..." : "- view less content"}
                </span>
            </div>
        </div>
    );
};

export default PanelInfoCollapsable;
